import { useEffect } from 'react';

const GOOGLE_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700&family=Roboto:wght@300;400;500;600;700&family=Outfit:wght@500;600;700&family=Inter+Tight:wght@600;700&family=JetBrains+Mono:wght@500;600&display=swap';

const LIBRE_CASLON_CSS = `
@font-face{font-family:'LibreCasCond';src:url(/marketing/fonts/libre-caslon-condensed-regular.woff2) format("woff2");font-weight:400;font-style:normal;font-display:swap}
@font-face{font-family:'LibreCasCond';src:url(/marketing/fonts/libre-caslon-condensed-italic.woff2) format("woff2");font-weight:400;font-style:italic;font-display:swap}
@keyframes lv-marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
:where(.lv-marketing) a{color:inherit;text-decoration:none}
:where(.lv-marketing) .lv-prose a{color:#0054f9;text-decoration:underline}
`;

/**
 * Loads the marketing site's fonts (Sora + Roboto via Google Fonts, Libre
 * Caslon Condensed self-hosted from public/marketing/fonts/ — SIL OFL v1.1,
 * see the bundled OFL.txt) once, on demand — only pages that render the
 * marketing site pay for them, not every authenticated route.
 */
export default function useMarketingFonts(): void {
  useEffect(() => {
    if (!document.getElementById('lv-google-fonts')) {
      const link = document.createElement('link');
      link.id = 'lv-google-fonts';
      link.rel = 'stylesheet';
      link.href = GOOGLE_FONTS_HREF;
      document.head.appendChild(link);
    }
    if (!document.getElementById('lv-libre-caslon')) {
      const style = document.createElement('style');
      style.id = 'lv-libre-caslon';
      style.textContent = LIBRE_CASLON_CSS;
      document.head.appendChild(style);
    }
  }, []);
}
